






































import { Component, Vue, Prop } from 'vue-property-decorator';


const toFormattedDate = (rawDate: string | null) => {
  let value = rawDate || '';
  if (value.length === 10) {
    let [year, month, day] = value.split('-');
    return `${month}${day}${year}`
  }
  return value;
}

const toRawDate = (formattedDate: string) => {
  if (formattedDate.length === 8) {
    let month = formattedDate.substr(0, 2);
    let day = formattedDate.substr(2, 2);
    let year = formattedDate.substr(4);
    return `${year}-${month}-${day}`;
  }
  return formattedDate;
}


@Component
export default class NewEntryPageDateInput extends Vue {
  @Prop() disabled!: boolean;
  @Prop() events!: string[];
  @Prop() hint!: string;
  @Prop() label!: string;
  @Prop() max!: string;
  @Prop() min!: string;
  @Prop() value!: string | null;
  pickerMenu = false;

  get inputLabel() {
    return this.label || 'Date';
  }

  get textBoxValue() {
    return toFormattedDate(this.value);
  }

  set textBoxValue(newValue: string) {
    this.$emit('input', toRawDate(newValue));
  }

  onPickerChange(newValue: string) {
    this.pickerMenu = false;
    this.textBoxValue = newValue;
  }
}
